import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center w-full h-14 absolute inset-0 pointer-events-none sm:justify-start md:justify-between md:h-auto sm:relative sm:pointer-events-auto" }
const _hoisted_2 = {
  id: "secondary-nav-left-panel",
  class: "flex justify-between items-center w-[65vw] py-1 px-2 pointer-events-auto sm:py-5 sm:px-xxl sm:w-full"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  id: "secondary-nav-right-panel",
  class: "hidden md:flex"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  id: "secondary-nav-bottom-panel",
  class: "md:flex bg-white flex-col"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", {
    id: "secondary-nav",
    ref: "header",
    class: _normalizeClass([_ctx.dynamicDomClasses, "sm:bg-white sm:shadow-sm md:flex-col"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", {
          id: "page-title",
          class: "text-md sm:text-2xl leading-8 font-bold block md:px-0 sm:mx-0 md:max-w-full overflow-hidden text-white sm:text-gray-900 mx-auto whitespace-nowrap overflow-ellipsis md:pointer-events-none",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args)))
        })
      ]),
      _hoisted_3
    ]),
    _hoisted_4
  ], 2))
}